import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { AccountBalanceWallet } from '@mui/icons-material';

const CTASection = () => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    return (
        <Box
            sx={{
                py: { xs: 10, md: 15 },
                position: 'relative',
                overflow: 'hidden',
                background: isDark ? '#080808' : '#fcfcfc',
                borderTop: `1px solid ${isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}`,
                textAlign: 'center'
            }}
        >
            {/* Background Glow */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '100%',
                    maxWidth: '800px',
                    height: '200px',
                    background: 'radial-gradient(circle, rgba(0, 240, 255, 0.08) 0%, transparent 70%)',
                    filter: 'blur(60px)',
                    zIndex: 0
                }}
            />

            <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <Typography
                        variant="h2"
                        fontWeight={900}
                        gutterBottom
                        sx={{
                            fontSize: { xs: '2.5rem', md: '4.5rem' },
                            color: theme.palette.text.primary,
                            mb: 3,
                            letterSpacing: '-0.02em'
                        }}
                    >
                        Ready to Start?
                    </Typography>

                    <Typography
                        variant="h6"
                        sx={{
                            color: theme.palette.text.secondary,
                            mb: 6,
                            maxWidth: '600px',
                            mx: 'auto',
                            lineHeight: 1.7,
                            fontWeight: 400
                        }}
                    >
                        Join thousands of users already earning rewards every day.
                        Sign up now and start your earning journey!
                    </Typography>

                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => window.location.href = '/login'}
                        startIcon={<AccountBalanceWallet />}
                        component={motion.button}
                        whileHover={{ scale: 1.05, boxShadow: '0 0 30px rgba(0, 240, 255, 0.4)' }}
                        whileTap={{ scale: 0.95 }}
                        sx={{
                            background: 'linear-gradient(90deg, #00F0FF 0%, #1d64fa 100%)',
                            color: '#fff',
                            px: 5,
                            py: 2,
                            borderRadius: '16px',
                            fontSize: '1.1rem',
                            fontWeight: 700,
                            textTransform: 'none',
                            boxShadow: '0 10px 25px rgba(0, 240, 255, 0.25)',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        Start Now
                    </Button>
                </motion.div>
            </Container>
        </Box>
    );
};

export default CTASection;
